module.exports = __webpack_public_path__ + "img/hygc.c42ecd96.png";